module.exports = __webpack_public_path__ + "img/updated.a81633af.svg";